<app-text-input
    id="key"
    label="service.operationalReport.type.fields.key"
    [form]="form"
></app-text-input>
